import React from 'react'
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { useLoader } from '@react-three/fiber'
import { useGLTF, useTexture } from '@react-three/drei'
import { useRef, useEffect } from 'react'

let c_leather = new THREE.TextureLoader().load('./model/c_leather.jpg')
c_leather.flipY = false

let normalMap = new THREE.TextureLoader().load('./model/c_normal.jpg')
normalMap.flipY = false
normalMap.flipX = true

let roughnessMap = new THREE.TextureLoader().load('./model/c_roughness.jpg')
roughnessMap.flipY = false

let w_01 = new THREE.TextureLoader().load('./model/w_01.jpg')
w_01.flipY = false

let w_normal = new THREE.TextureLoader().load('./model/w_normal.jpg')
w_normal.flipY = false
w_normal.flipX = true

let w_roughness = new THREE.TextureLoader().load('./model/w_roughness.jpg')
w_roughness.flipY = false

const INITIALChair_MTL = new THREE.MeshStandardMaterial({
  map: c_leather,
  normalMap: normalMap,
  roughnessMap: roughnessMap,
})

const INITIALWood_MTL = new THREE.MeshStandardMaterial({
  map: w_01,
  normalMap: w_normal,
  roughnessMap: w_roughness,
})

const INITIAL_MAP = [
  { childID: 'cushion', mtl: INITIALChair_MTL },
  { childID: 'wood', mtl: INITIALWood_MTL },
]

const initColor = (parent, type, mtl) => {
  parent.traverse((o) => {
    if (o.isMesh && o.name.includes(type)) {
      o.castShadow = true
      o.receiveShadow = true
      o.material = mtl
      o.nameID = type
    }
  })
}

const ChairMesh = ({ newMaterialOpt }) => {
  const { scene: theModel } = useGLTF('./model/chair.glb')
  const chair = useRef(theModel)

  useEffect(() => void setMaterial(newMaterialOpt.activeOption, newMaterialOpt.newMTL), [newMaterialOpt.newMTL])

  useEffect(() => {
    if (theModel) {
      for (let object of INITIAL_MAP) {
        initColor(theModel, object.childID, object.mtl)
      }
    }
  }, [theModel])

  const setMaterial = (type, mtl) => {
    theModel.traverse((o) => {
      if (o.isMesh && o.nameID != null) {
        if (o.nameID === type) {
          o.material = mtl
        }
      }
    })
  }

  return <primitive ref={chair} object={theModel} scale={[1, 1, 1]} rotation={[0, -0.5, 0]} position={[0, -1, 0]} receiveShadow castShadow></primitive>
}

export default ChairMesh
